import { render, staticRenderFns } from "./RegistSuccess.vue?vue&type=template&id=4c281460&scoped=true"
import script from "./RegistSuccess.vue?vue&type=script&lang=js"
export * from "./RegistSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c281460",
  null
  
)

export default component.exports